var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center gap-16"},[_c('dv-btn',{attrs:{"to":{ name: 'login' }}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":20}},[_vm._v("$ui-user-plus")]),_c('p',[_vm._v("Авторизация")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }